angular
    .module('webcomm')
    .factory('anchorInfoService', ['$log', '$timeout', '$rootScope', function ($log, $timeout, $rootScope) {
        // This is a very basic implementation. The Proxy as of build 5.12.61981 ignores anchor info. This service
        // will need to be heavily modified once we start implementing "virtual" views

        /**** Anchor type
         1.	RowIndex
         2.	Percent
         3.	Page
         4.	Start Char (UTF-8 char code)
         5.	Offset
         ****/
        const pageSize = 100; 
         let service = {

            createAnchor() {
                $log.debug("anchorInfoService: creating a new AnchorInfo for getting first " + pageSize + " entries");
                let ai = new WtcpJs.AnchorInfo();
                ai.value = 0; // start first list
                ai.type = 1; // Row Index
                ai.before = 0;
                ai.after  = pageSize - 1;
                return ai;
            },

            getNextSet(ai) {
                ai.value += pageSize; // add it by pageSize
                ai.type = 1; // row index
                ai.before = 0;
                ai.after += pageSize;
                $log.debug("getNext : value="+ai.value+",type="+ai.type+",before="+ai.before+",after="+ai.after);
                return ai;
            },

            getNextAnchorOnStartChar(key) {
                $log.debug("getNextPageBasedOnStartChar [" + key + "]");
                let ai = new WtcpJs.AnchorInfo(); 
                ai.value = key.charCodeAt(0);
                ai.type = 4; //start Char based
                ai.before = 0;
                ai.after = pageSize;
                return ai;
            }
        }

        return service;
    }]);